import { toJpeg } from 'html-to-image';

async function aDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

async function inlineImagenes(doc: Document): Promise<void> {
  const imgs = Array.from(doc.images);
  await Promise.all(
    imgs.map(async (img) => {
      const src = img.getAttribute('src') || '';
      if (!src || src.startsWith('data:')) return;
      try {
        const res = await fetch(src, { mode: 'cors' });
        if (!res.ok) return;
        img.src = await aDataUrl(await res.blob());
      } catch {
        /* la vista previa sigue; el JPEG puede omitir esa foto */
      }
    })
  );
}

export async function exportarJpeg(doc: Document, width: number, height: number): Promise<Blob> {
  await inlineImagenes(doc);
  const fonts = doc.fonts;
  if (fonts?.ready) await fonts.ready;
  const marcados = Array.from(doc.querySelectorAll('.clientelo-slot-activo'));
  marcados.forEach((el) => el.classList.remove('clientelo-slot-activo'));
  let dataUrl: string;
  try {
    dataUrl = await toJpeg(doc.body, {
      quality: 0.92,
      width,
      height,
      canvasWidth: width,
      canvasHeight: height,
      pixelRatio: 1,
      skipAutoScale: true,
    });
  } finally {
    marcados.forEach((el) => el.classList.add('clientelo-slot-activo'));
  }
  const res = await fetch(dataUrl);
  return res.blob();
}
